// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"ReferFriendCopyLink_skeleton__k9hcq"};